const ADD_TO_COMPARE = {
  key: 'compare',
  label: 'Add to Compare',
  mobileOnly: false,
};

export const PAUSE = {
  key: 'pause',
  label: 'Pause',
  mobileOnly: false,
};

export const RESUME = {
  key: 'resume',
  label: 'Resume',
  mobileOnly: false,
};

export const CANCEL_SIP_PLUS = {
  key: 'cancel',
  label: 'Cancel',
  mobileOnly: false,
};

export const SWITCH_MANDATE = {
  key: 'switch_mandate',
  label: 'Switch Mandate',
  mobileOnly: false,
};

export const topFundsActions = [
  {
    key: 'invest',
    label: 'Invest',
    mobileOnly: true,
  },
  ADD_TO_COMPARE,
];

export const searchPageActions = [
  {
    key: 'invest',
    label: 'Invest',
    mobileOnly: true,
  },
  ADD_TO_COMPARE,
];

export const processingOrdersActions = [
  {
    key: 'cancel',
    label: 'Cancel',
    mobileOnly: false,
  },
];

export const dashboardActions = {
  portfolio: [
    // {
    //   key: 'invest',
    //   label: 'Invest more',
    //   mobileOnly: true,
    // },
    // {
    //   key: 'redeem',
    //   label: 'Redeem',
    //   mobileOnly: false,
    // },
    ADD_TO_COMPARE,
  ],
  sip: [],
};

export const bankActions = {
  primary: [
    {
      key: 'mandate',
      label: 'Create Mandate',
      mobileOnly: false,
      icon:
        'https://assets1.cleartax-cdn.com/clearsave/images/1640241262_copy.svg',
    },
  ],
  secondary: [
    {
      key: 'primary',
      label: 'Make primary',
      mobileOnly: false,
      icon:
        'https://assets1.cleartax-cdn.com/clearsave/images/1640241276_bank.svg',
    },
    // {
    //   key: 'mandate',
    //   label: 'Create Mandate',
    //   mobileOnly: false,
    //   icon: 'https://assets1.cleartax-cdn.com/clearsave/images/1640241262_copy.svg',
    // },
    {
      key: 'delete',
      label: 'Delete',
      mobileOnly: false,
      icon:
        'https://assets1.cleartax-cdn.com/clearsave/images/1640241288_trash.svg',
    },
  ],
};



// WEBPACK FOOTER //
// ./constants/actionMenu.ts